<section class="flex-container" *ngIf="showAll && !donutsEtiquetadoresInput">
    <div *ngFor="let expedicion of expedicionCero">
        <div *ngIf="expedicion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{expedicion.label}}</label>
            <label [ngClass]="{'remove-label': !expedicion.subLabel}">{{expedicion.subLabel ? expedicion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="expedicion.labelList" [dataList]="expedicion.dataList" [chartName]="'x'" [colors]="expedicion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(expedicion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(expedicion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let expedicion of expedicionDesignados">
        <div *ngIf="expedicion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{expedicion.label}}</label>
            <label [ngClass]="{'remove-label': !expedicion.subLabel}">{{expedicion.subLabel ? expedicion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="expedicion.labelList" [dataList]="expedicion.dataList" [chartName]="'x'" [colors]="expedicion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(expedicion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(expedicion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let reetiquetado of reetiquetados">
        <div *ngIf="reetiquetado !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{reetiquetado.label}}</label>
            <label [ngClass]="{'remove-label': !reetiquetado.subLabel}">{{reetiquetado.subLabel ? reetiquetado.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="reetiquetado.labelList" [dataList]="reetiquetado.dataList" [chartName]="'x'" [colors]="reetiquetado.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(reetiquetado.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(reetiquetado)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let etiqueta of etiquetasReimpresas">
        <div *ngIf="etiqueta !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{etiqueta.label}}</label>
            <label [ngClass]="{'remove-label': !etiqueta.subLabel}">{{etiqueta.subLabel ? etiqueta.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="etiqueta.labelList" [dataList]="etiqueta.dataList" [chartName]="'x'" [colors]="etiqueta.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(etiqueta.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(etiqueta)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let confeccion of confecciones">
        <div *ngIf="confeccion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{confeccion.label}}</label>
            <label [ngClass]="{'remove-label': !confeccion.subLabel}">{{confeccion.subLabel ? confeccion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="confeccion.labelList" [dataList]="confeccion.dataList" [chartName]="'x'" [colors]="confeccion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(confeccion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(confeccion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let denominacion of denominaciones">
        <div *ngIf="denominacion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{denominacion.label}}</label>
            <label [ngClass]="{'remove-label': !denominacion.subLabel}">{{denominacion.subLabel ? denominacion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="denominacion.labelList" [dataList]="denominacion.dataList" [chartName]="'x'" [colors]="denominacion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(denominacion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(denominacion)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let falloConexion of fallosConexion">
        <div *ngIf="falloConexion !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{falloConexion.label}}</label>
            <label [ngClass]="{'remove-label': !falloConexion.subLabel}">{{falloConexion.subLabel ? falloConexion.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="falloConexion.labelList" [dataList]="falloConexion.dataList" [chartName]="'x'" [colors]="falloConexion.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(falloConexion.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(falloConexion)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let activo of activos">
        <div *ngIf="activo !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{activo.label}}</label>
            <label [ngClass]="{'remove-label': !activo.subLabel}">{{activo.subLabel ? activo.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="activo.labelList" [dataList]="activo.dataList" [chartName]="'x'" [colors]="activo.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(activo.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(activo)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let activo of activosImprimiendo">
        <div *ngIf="activo !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{activo.label}}</label>
            <label [ngClass]="{'remove-label': !activo.subLabel}">{{activo.subLabel ? activo.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="activo.labelList" [dataList]="activo.dataList" [chartName]="'x'" [colors]="activo.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(activo.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(activo)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
    <div *ngFor="let almacen of almacenes">
        <div *ngIf="almacen !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{almacen.label}}</label>
            <label [ngClass]="{'remove-label': !almacen.subLabel}">{{almacen.subLabel ? almacen.subLabel : 'Sin subLabel'}}</label>
            <lib-dougnhut-chart [labelList]="almacen.labelList" [dataList]="almacen.dataList" [chartName]="'x'" [colors]="almacen.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(almacen.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}" (click)="showGrid(almacen)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="!showAll">
    <div *ngFor="let donut of donutsPorPrioridad">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid"  [ngClass]="{'disabled': !cargaCompleta}"(click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<section class="flex-container" *ngIf="showAll && donutsEtiquetadoresInput">
    <div *ngFor="let donut of allDonuts">
        <div *ngIf="donut !== undefined" class="donut" [ngClass]="animation ? 'all' : ''">
            <label>{{donut.label}}</label>
            <label>{{donut.subLabel}}</label>
            <lib-dougnhut-chart [labelList]="donut.labelList" [dataList]="donut.dataList" [chartName]="'x'" [colors]="donut.colors"></lib-dougnhut-chart>
            <div class="buttons-section">
                <button id="info" [tooltip]="(donut.descripcion)"><i class="fa-solid fa-info"></i></button>
                <button class="grid" [ngClass]="{'disabled': !cargaCompleta}"  (click)="showGrid(donut)" [tooltip]="('central-avisos.mostrarTabla' | translate)"><i class="fas fa-table"></i></button>
            </div>
        </div>
    </div>
</section>
<div class="modal" *ngIf="gridModal">
    <div class="modal-content">
        <header>
            <h4>{{tituloGrid}}</h4>
            <i class="fas fa-times" (click)="gridModal = !gridModal"></i>
          </header>
        <app-grid-central-avisos [titulo]="tituloGrid" [dataExpedicionCero]="dataExpedicionCero" (refresh)="refresh($event)" (emitDataExpedicionCero)="getDataExpedicionCero($event)"></app-grid-central-avisos>
    </div>
</div>